var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-progress-linear',{attrs:{"indeterminate":"","linear":""}}),_c('div',{staticClass:"text-h6 text-center py-6"},[_vm._v("Saindo...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }